import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { vendas } from '../../../db/colunas';
import { RelatorioService } from 'src/app/core/services/relatorios.service';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { formatDate } from '@angular/common';
import { error } from 'console';
@Component({
  selector: 'page-relatorios',
  templateUrl: './page-relatorios.component.html',
  styleUrls: ['./page-relatorios.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class PageRelatoriosComponent {
  public formSearch: FormGroup;
  @ViewChild('colunaDeAcao', {static: false})
  colunaDeAcao: TemplateRef<any>;
  loading = false

  data: {
    data_inicial: "2023-11-10",
    data_final: "2025-11-10"
  }
  public ranges: any = [
    {
      value: [
        new Date(),
        new Date(new Date().setDate(new Date().getDate())),,
      ],
      label: $localize`Hoje`,
    },
    {
      value: [
        new Date(new Date().setDate(new Date().getDate() - 7)),
        new Date(),
      ],
      label: $localize`Últimos 7 Dias`,
    },
    {
      value: [
        new Date(),
        new Date(new Date().setMonth(new Date().getMonth())),
      ],
      label: $localize`Mês Atual`,
    },
    {
      value: [
        new Date(new Date().setMonth(new Date().getMonth() - 1)),
        new Date(),
      ],
      label: $localize`Último mês`,
    },
  ];
  colunas: any[] = [$localize`Classificação`,$localize`Total`, $localize`Percentual`];

  linhas = [];

  
  constructor(
    public relatorioService: RelatorioService,
    private formBuilder: FormBuilder,
    public toastService: ToastrService,
  ) {
    this.formSearch = this.formBuilder.group({

      data: [[]],
    });
   }
  
  // ngAfterViewInit(): void {
  //   //this.montaColunas();
  //   this.relatorioService.getRelatorios(this.data,
  //     function (resp) {
  //       console.log(resp)
  //       this.linhas = resp
  //     }.bind(this))
  // }
  filterData(){
    if(this.formSearch.status === 'INVALID'){
      this.toastService.warning("Insira uma data válida", $localize`Relatorios`, {
        positionClass: "toast-bottom-right",
      });
      return
    }
    this.loading = true
    let dataInicial = formatDate(
      this.formSearch.value.data[0],
      "dd/MM/yyyy",
      "en"
    );
    let dataFinal = formatDate(
      this.formSearch.value.data[1],
      "dd/MM/yyyy",
      "en"
    );
    // dataInicial = dataInicial.slice(-4) + "-" + dataInicial.slice(3, 5) + "-" + dataInicial.slice(0, 2)
    // dataFinal = dataFinal.slice(-4) + "-" + dataFinal.slice(3, 5) + "-" + dataFinal.slice(0, 2)
    this.relatorioService.getRelatorios({ dataInicial: dataInicial, dataFinal: dataFinal },
      function (resp) {
        // console.log(resp)
        this.linhas = resp
        this.loading = false
      }.bind(this), this.callBackError.bind(this))
  }
  callBackError(error){
    this.loading = false
    this.toastService.warning(JSON.parse(error._body).detail, $localize`Relatorios`, {
      positionClass: "toast-bottom-right",
    });
  }
}
